import {
    SET_DISPOSITION_PAYMENT_SAVE_STATUS,
    SET_DISPOSITION_PAYMENT_DATA
} from "./FleetDispositionPaymentSaveType"

const initialState = {
    status: null,
    dispositionPaymentData: <any>[]
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_DISPOSITION_PAYMENT_SAVE_STATUS:
            return {
                ...state,
                status: action.status
            };
        case SET_DISPOSITION_PAYMENT_DATA:
            return {
                ...state,
                dispositionPaymentData: action.paymentData
            };
        default:
            return state;
    }
};

export default reducer;